import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		alert: {
			marginBottom: 15,
		},
		importButtonsContainer: {
			position: "sticky", 
			top: 64, 
			zIndex: 1000, 
			backgroundColor: theme.palette.background.default
		},
		importButtons: {
			paddingTop: 5,
			paddingBottom: 5,
		},
		hidden: {
			display: "none",
		},
		uploadIntroContainer: {
			gap: theme.spacing(3),
		},
		uploadIntroText: {
			color: "#1C1B1F",
			fontSize: "1rem",
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: 1.25,
		},
		templateLinkText: {
			verticalAlign: "middle",
			display: "inline-flex",
			alignItems: "center",
			gap: theme.spacing(0.75),
			color: "#3D9BE1",
			fontSize: "1rem",
			fontStyle: "normal",
			fontWeight: 500,
			lineHeight: 1.25,
		},
		parsingText: {
			color: "#5f6368",
			fontSize: "0.875rem",
		},
		bypassList: {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
		},
		bypassCounts: {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
		},
		invalidHeaderChip: {
			margin: theme.spacing(0.375),
		},
		downloadIcon: {
			marginRight: 5,
		},
		csvLink: {
			textDecoration: theme.palette.text.primary,
			color: theme.palette.primary.main,
		},
		tooltip: {
			fontSize: "1rem",
		},
		fullWidth: {
			width: "100%",
		}
	} satisfies Record<string, CSSObject>);
};
